import { Component, EventEmitter, Output } from '@angular/core';
import { ProductTranslationParams } from '@go-modules/interfaces';
import { ActiveBrandService } from '@go-modules/services/active-brand';

@Component({
	selector: 'student-signup-message',
	templateUrl: './student-signup-message.component.html',
	styleUrls: [
		'./student-signup-message.component.scss'
	],
	standalone: false
})
export class StudentSignupMessageComponent {
	@Output() public onBack = new EventEmitter(); // eslint-disable-line @angular-eslint/no-output-on-prefix

	constructor (
		public activeBrandService: ActiveBrandService
	) {}

	public get translationParams (): ProductTranslationParams {
		return this.activeBrandService.getTranslationParams();
	}
}
